// DS: i1.10
import React from 'react';
import IconWrap from '../../IconWrap';
const Tier = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "24",
        height: "24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M19.8552 9.32401L18.0965 18.1176C18.0404 18.3981 17.7941 18.5999 17.5081 18.5999H6.49189C6.20588 18.5999 5.95963 18.3981 5.90354 18.1176L4.14482 9.32401C4.08252 9.01253 4.39068 8.7562 4.68561 8.87418L9 10.5999L11.6422 5.31547C11.7896 5.02066 12.2104 5.02066 12.3578 5.31547L15 10.5999L19.3144 8.87418C19.6093 8.7562 19.9175 9.01253 19.8552 9.32401Z"
    })));
Tier.displayName = 'Tier';
export default Tier;
